module.exports = __webpack_public_path__ + "media/gds.d0959eee.mp4";